// Ported from src/views/common/constants.js's ICON_BY_TYPE — that file lives
// in the legacy views tree (not src/core/), so per the v2 migration convention
// this is duplicated here rather than imported directly.
const ICON_BY_TYPE = {
  default: { title: "-", className: "default" },
  "application/pdf": { title: "PDF", className: "pdf" },
  "image/png": { title: "PNG", className: "png" },
  "image/jpg": { title: "JPG", className: "jpg" },
  "image/jpeg": { title: "JPG", className: "jpg" },
  "application/msword": { title: "DOC", className: "doc" },
  "application/vnd.ms-excel": { title: "XLS", className: "xls" },
  "text/csv": { title: "CSV", className: "xls" },
  "application/vnd.ms-powerpoint": { title: "PPT", className: "ppt" },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": { title: "DOCX", className: "docx" },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": { title: "XLSX", className: "xlsx" },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": { title: "PPTX", className: "pptx" },
  "application/vnd.ms-word.document.macroEnabled.12": { title: "DOC", className: "doc" },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": { title: "XLSX", className: "xlsx" },
  "application/vnd.ms-word.template.macroEnabled.12": { title: "DOC", className: "doc" },
  "application/vnd.ms-powerpoint.presentation.macroEnabled.12": { title: "PPT", className: "ppt" },
  "application/vnd.openxmlformats-officedocument.presentationml.template": { title: "PPTX", className: "pptx" },
  "application/vnd.ms-powerpoint.template.macroEnabled.12": { title: "PPT", className: "ppt" },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": { title: "PPTX", className: "pptx" },
  "application/vnd.ms-powerpoint.slideshow.macroEnabled.12": { title: "PPT", className: "ppt" },
  "application/vnd.google-apps.spreadsheet": { title: "GSHEET", className: "gsheet" },
  "application/vnd.google-apps.document": { title: "GDOC", className: "gdoc" },
  "application/vnd.google-apps.presentation": { title: "GSLIDE", className: "gslide" },
  "image/svg+xml": { title: "SVG", className: "svg" },
};

const BADGE_COLORS = {
  pdf: "bg-red-500",
  doc: "bg-blue-500",
  docx: "bg-blue-500",
  xls: "bg-green-600",
  xlsx: "bg-green-600",
  ppt: "bg-orange-500",
  pptx: "bg-orange-500",
  gsheet: "bg-green-600",
  gdoc: "bg-blue-500",
  gslide: "bg-orange-500",
  png: "bg-purple-500",
  jpg: "bg-purple-500",
  svg: "bg-purple-500",
  default: "bg-slate-400",
};

// Download-only uploads can be any file type, not just the PDF/office types
// ICON_BY_TYPE recognizes (those came from the legacy annotatable-only list).
// For anything unrecognized, fall back to the file's own extension rather
// than a meaningless "-", since that's still real, useful information.
function extensionLabel(fileName) {
  const match = /\.([a-z0-9]+)$/i.exec(fileName ?? "");
  return match ? match[1].toUpperCase() : null;
}

export function getFileTypeLabel(mimeType, fileName) {
  return ICON_BY_TYPE[mimeType]?.title ?? extensionLabel(fileName) ?? ICON_BY_TYPE.default.title;
}

export function getFileTypeBadgeClass(mimeType) {
  const className = ICON_BY_TYPE[mimeType]?.className ?? "default";
  return BADGE_COLORS[className] ?? BADGE_COLORS.default;
}
